import { Component, Input, OnChanges } from '@angular/core';
import { Activity } from '../models';

interface Zone {
  color: string;
  percentage: number;
  duration: number;
  name: string;
  limitUp: number;
  limitDown: number;
}
@Component({
  selector: 'app-zones',
  templateUrl: './zones.component.html',
  styleUrls: ['./zones.component.scss'],
})
export class ZonesComponent implements OnChanges {
  @Input() heartRate: number[];
  @Input() activity: Activity;
  zones: Zone[];
  constructor() {}

  ngOnChanges() {
    this.categorizeHeartRates(this.heartRate, this.activity.elapsed_time);
  }

  categorizeHeartRates(heartRate: number[], totalDuration: number) {
    const athleteYear = localStorage.getItem('age');
    const age = athleteYear
      ? new Date().getUTCFullYear() - parseInt(localStorage.getItem('age'), 10)
      : 30;
    const maxHeartRate = localStorage.getItem('heartrate');
    const max = maxHeartRate ? Number(maxHeartRate) : 220 - age;
    const ranges = {
      zone0: 0,
      zone1: 0,
      zone2: 0,
      zone3: 0,
      zone4: 0,
      zone5: 0,
    };
    const colors = {
      zone0: 'white',
      zone1: '#989898',
      zone2: '#00A8D8',
      zone3: '#00A860',
      zone4: '#F8A820',
      zone5: '#F04040',
    };

    const names = {
      zone0: 'nozone',
      zone1: 'Warm Up',
      zone2: 'Easy',
      zone3: 'Aerobic',
      zone4: 'Threshold',
      zone5: 'Maximum',
    };
    heartRate.forEach((rate) => {
      const percentage = (rate / max) * 100;
      if (percentage < 50) {
        ranges.zone0++;
      } else if (percentage >= 50 && percentage < 60) {
        ranges.zone1++;
      } else if (percentage >= 60 && percentage < 70) {
        ranges.zone2++;
      } else if (percentage >= 70 && percentage < 80) {
        ranges.zone3++;
      } else if (percentage >= 80 && percentage < 90) {
        ranges.zone4++;
      } else {
        ranges.zone5++;
      }
    });
    const total = heartRate.length;
    const percentages = Object.keys(ranges)
      .reverse()
      .map((count, index) => ({
        name: names[count],
        limitUp: Math.round(max - 1 - (index * max) / 10),
        limitDown: Math.round(max - ((index + 1) * max) / 10),
        percentage: Math.round((ranges[count] / total) * 100),
        duration: Math.round((ranges[count] / total) * totalDuration),
        color: colors[count],
      }));
    this.zones = percentages.filter((zone) => zone.name !== 'nozone');
  }
}
